import type { BlockKey } from './types.ts';

export type EditorTraitMode = 'simple' | 'advanced';

const SIMPLE_TEMPLATE_IDS = [
  'home/hero-split',
  'home/hero-centered',
  'home/masonry-promo',
  'about/team-focus',
  'about/timeline',
  'about/mission-stats',
  'contact/simple-form',
  'contact/map-info',
  'contact/split-form',
  'blog/list-sidebar',
  'blog/grid-cards',
  'blog/featured-plus-list',
  'eshop/item-card',
  'eshop/category-highlight',
  'eshop/category-showcase',
  'eshop/category-carousel',
  'eshop/float-buttons',
] as const;

const SIMPLE_TEMPLATE_SET = new Set<string>(SIMPLE_TEMPLATE_IDS);

export const SIMPLE_MODE_BLOCKS: BlockKey[] = Array.from(
  new Set(
    SIMPLE_TEMPLATE_IDS.map((templateId) => templateId.split('/')[0] as BlockKey),
  ),
);

const SIMPLE_TRAIT_ALLOWLIST: Record<string, readonly string[]> = {
  'home/hero-split': ['data-style'],
  'home/hero-centered': ['data-style'],
  'home/masonry-promo': ['data-style'],
  'about/team-focus': ['data-style'],
  'about/timeline': ['data-style'],
  'about/mission-stats': ['data-style'],
  'blog/list-sidebar': ['data-style'],
  'blog/grid-cards': ['data-style'],
  'blog/featured-plus-list': ['data-style'],
  'eshop/item-card': ['data-config'],
  'eshop/category-highlight': ['data-config'],
  'eshop/category-showcase': ['data-config'],
  'eshop/category-carousel': ['data-config'],
  'eshop/float-buttons': ['data-config'],
};

export function isTemplateAllowedInSimple(templateId: string): boolean {
  return SIMPLE_TEMPLATE_SET.has(templateId);
}

export function getSimpleModeAllowedTraits(templateId: string | null | undefined): readonly string[] {
  if (!templateId) {
    return [];
  }
  return SIMPLE_TRAIT_ALLOWLIST[templateId] ?? [];
}

export function getSimpleModeTemplateIds(): readonly string[] {
  return SIMPLE_TEMPLATE_IDS;
}
